import * as serviceWorker from '@/serviceWorker';
import * as Sentry from '@sentry/browser';
import 'antd/lib/style/index.less'; // antd core styles
import dotenv from 'dotenv';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import Routes from 'routes';
import './@kit/vendors/antd/themes/dark.less'; // dark theme antd components
import './@kit/vendors/antd/themes/default.less'; // default theme antd components
import { SignerProvider } from './contexts/SignerContext';
import { ThemeProvider } from './contexts/ThemeContext';
import './global.scss'; // app & third-party component styles
import { AnyType } from './type';
import './style.css';

dotenv.config();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({ dsn: 'https://c84f59fed8c54bd9b8b00ba23519ad71@exception.nesbilgi.com.tr/13' });
}

const AppRoutes = () => <Route path="*" render={(props: AnyType) => <Routes {...props} />} />;

ReactDOM.render(
  <BrowserRouter>
    <ThemeProvider>
      <SignerProvider>
        <AppRoutes />
      </SignerProvider>
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
